import { defineComponent as _defineComponent } from 'vue'
import AdminNavigation from "../../AdminNavigationContainer.vue";
import Alert from "@/components/scan/parts/Alert.vue";
import { ref, onMounted, reactive } from "vue";
import AdminInfoDataService from "@/services/AdminInfoDataService";
import UserInfoDataService from "@/services/UserInfoDataService";
import { store } from "@/store/store";

import { useI18n } from "vue3-i18n";
import ResponseData from "@/types/ResponseData";


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();

const isLoading = ref(false);
const i18n = useI18n();
const title1 = ref("Add Station Code");
const title2 = ref("Edit Station Code");
const selectedAreaCode = ref("");
const selectedCountryCode = ref("");
const CompanyName = ref("");
const StationCode = ref("");
const ThreeDigit = ref("");
const ParentCode = ref("");
const titleStatus = ref("");

const areaInfo = reactive([]);
const oriCountryInfo = reactive([]);
const countryInfo = reactive([]);

const alertMessage = ref("null");
const alertState = ref("neutral");
const areaError = ref("");
const countryError = ref("");
const companyError = ref("");
const stationError = ref("");
const threeDigitCdError = ref("");
const parentCdError = ref("");
const checkVal = ref(true);
const validStCD = ref("F");
const validThreeDigit = ref("F");
const validParentCD = ref("F");

onMounted(function () {
  isLoading.value = true;
  // const UserParam = new URLSearchParams(location.search);
  titleStatus.value = store.getters.status;
  if (store.getters.status == "Edit") {
    selectedAreaCode.value = store.getters.editStationData.areaCode;
    selectedCountryCode.value = store.getters.editStationData.countryCode;
    CompanyName.value = store.getters.editStationData.companyName;
    StationCode.value = store.getters.editStationData.stationCode;
    ThreeDigit.value = store.getters.editStationData.threeDigitCode;
    ParentCode.value = store.getters.editStationData.parentCode;
  }
  getAreaAndCountry();
});

//エリアと国の情報取得処理
const getAreaAndCountry = async () => {
  isLoading.value = true;
  await Promise.all([
    getAreaList(),
    getCountryList()
  ]);
};

const getAreaList = () => {
  areaInfo.splice(0);
  // get Area Data
  AdminInfoDataService.getAreaInfo()
  .then((response: ResponseData) => {
    if (response.data.length !== 0) {
      for (let info of response.data) {
        areaInfo.push(info);
      }
    }
    isLoading.value = false;
  })
  .catch((_) => {
    alertMessage.value = i18n.t("err057");
    alertState.value = "error";
    isLoading.value = false;
  });
}

const getCountryList = () => {
  oriCountryInfo.splice(0); 
  // get Country Data
  AdminInfoDataService.getCountryInfo()
  .then((response: ResponseData) => {
    var resResult = response.data;
    if (resResult.length !== 0) {
      oriCountryInfo.value = resResult;
    }
    setCountryByArea();
    isLoading.value = false;
  })
  .catch((_) => {
    alertMessage.value = i18n.t("err021");
    alertState.value = "error";
    isLoading.value = false;
  });
}

const setCountryByArea = () => {
  countryInfo.splice(0);
  for (let countryData of oriCountryInfo.value) {
    if(countryData.areaCode.areaCode == selectedAreaCode.value || selectedAreaCode.value == ""){
      countryInfo.push(countryData);
    }
  }
}

const areaChange = (event: { target: { value: any; }; }) => {
  selectedAreaCode.value = event.target.value;
  selectedCountryCode.value = "";
  setCountryByArea();
};

const stationAddOrEditProcess = (param1) => {
  checkVal.value = true;
  alertMessage.value = "null";
  alertState.value = "neutral";

  //[Area]が選択したかどうかチェック
  if (!selectedAreaCode.value.trim()) {
    areaError.value = i18n.t("alt027");
    checkVal.value = false;
  } else {
    areaError.value = "";
  }

  //[Country]のチェック
  if (!selectedCountryCode.value.trim()) {
    countryError.value = i18n.t("alt028");
    checkVal.value = false;
  } else {
    countryError.value = "";
  }

  //[Company]のチェック
  if ( 
    !CompanyName.value.trim() ||
    !validCompanyName(CompanyName.value.trim())) {
    companyError.value = i18n.t("alt029");
    checkVal.value = false;
  }else {
    companyError.value = "";
  }

  //[Station Code]のチェック
  if (
    !StationCode.value.trim() || 
    StationCode.value.trim().length != 4 ||
    !validStation_ParentCode(StationCode.value.trim())) {
    stationError.value = i18n.t("alt025");
    checkVal.value = false;
  } else {
    validStCD.value = "T";
    stationError.value = "";
  }

  //[Parent Code]のチェック
  if(ParentCode.value == null){
    parentCdError.value = i18n.t("alt072");
    checkVal.value = false;
  }else if (
    !ParentCode.value.trim() ||
    ParentCode.value.trim().length != 6 ||
    !validStation_ParentCode(ParentCode.value.trim())
  ) {
    parentCdError.value = i18n.t("alt072");
    checkVal.value = false;
  } else {
    validParentCD.value = "T";
    parentCdError.value = "";
  }

  //[3 Three Digit Code]のチェック
  if(ParentCode.value == null){
    threeDigitCdError.value = i18n.t("alt030");
    checkVal.value = false;
    return;
  }else if (
    !ThreeDigit.value.trim() ||
    ThreeDigit.value.trim().length != 3 ||
    !validThreeDCode(ThreeDigit.value.trim())
    ) {
      threeDigitCdError.value = i18n.t("alt030");
      checkVal.value = false;
      return;
    } else {
      validThreeDigit.value = "T";
      threeDigitCdError.value = "";
    }
  
  if(checkVal.value){
    if (validStCD.value == "T" || validThreeDigit.value == "T" ||  validParentCD.value == "T") {
      checkCompanyDetailInfo(param1);
    }
  }
};

const checkCompanyDetailInfo = (btnName) => {
  const data = {
    stationCode: StationCode.value.toUpperCase(),
    companyName: CompanyName.value.toUpperCase(),
    threeDigit: ThreeDigit.value.toUpperCase(),
    parentCode: ParentCode.value.toUpperCase(),
    btnMode: btnName,
  };

  UserInfoDataService.checkCompanyDetailInfo(data)
    .then((response: ResponseData) => {
      var errorList = response.data;
      threeDigitCdError.value = "";
      alertMessage.value = "null";
      alertState.value = "neutral";
      if (errorList["validStationCode"] && errorList["valid3DigitCode"]) {
        if (errorList["duplicate3DigitCode"]) {
          if (confirm("Three digit code is already used.Are you sure to continue?")) {
              if (btnName == "Add") {
                if (!errorList["validStationCode"]) {
                  alertMessage.value =
                    "Failed " + btnName + "." + i18n.t("alt026");
                  alertState.value = "error";
                  isLoading.value = false;
                } else {
                  //StationDataの登録処理
                  insertOrUpdateStationInfo(btnName);
                }
              } else if (btnName == "Edit") {
                //StationDataの編集処理
                insertOrUpdateStationInfo(btnName);
              }
          }else{
            isLoading.value = false;
          }
        } 
        else {
          insertOrUpdateStationInfo(btnName);
        }
      } else if (!errorList["valid3DigitCode"]) {
        threeDigitCdError.value = i18n.t("alt061");
      } else if (!errorList["validStationCode"] && btnName == "Add") {
        alertMessage.value = "Failed " + btnName + "." + i18n.t("alt026");
        alertState.value = "error";
        isLoading.value = false;
      }
    })
    .catch((_) => {
      alertMessage.value = i18n.t("err018");
      alertState.value = "error";
      isLoading.value = false;
    });
};

const insertOrUpdateStationInfo = (btnName: string) => {
  StationCode.value = StationCode.value.toUpperCase();
  CompanyName.value = CompanyName.value.toUpperCase();
  ThreeDigit.value = ThreeDigit.value.toUpperCase();
  ParentCode.value = ParentCode.value.toUpperCase();
  const userinfoData = {
    areaCode: selectedAreaCode.value,
    countryCode: selectedCountryCode.value,
    companyName: CompanyName.value,
    stationCode: StationCode.value,
    digit3_cd: ThreeDigit.value,
    parentCode: ParentCode.value,
    btnName: btnName,
  };
  AdminInfoDataService.insertOrUpdateStationInfo(userinfoData)
    .then((resStationData: ResponseData) => {
      var oriCompanyList = [];
      var returnData = resStationData.data.companyData;
      if(btnName == "Add"){
        var isAdded = false;
        for(let stObj of store.getters.stationListData){
          if(returnData[0].stationCode < stObj.stationCode && !isAdded){
            oriCompanyList.push(returnData[0]);
            isAdded = true;
          }
          oriCompanyList.push(stObj);
        }
        if(isAdded == false){
          oriCompanyList.push(returnData[0]);
        }
        store.dispatch("setStationListData", oriCompanyList);
        alertMessage.value = i18n.t("suc012");
        alertState.value = "success";
        isLoading.value = false;
      }else{
        for(let stObj of store.getters.stationListData){
          if(returnData[0].stationCode == stObj.stationCode){
            oriCompanyList.push(returnData[0]);
          }else{
            oriCompanyList.push(stObj);
          }
        }
        store.dispatch("setStationListData", oriCompanyList);
        alertMessage.value = i18n.t("suc028");
        alertState.value = "success";
        isLoading.value = false;
      }
    })
    .catch((_) => {
      if(btnName == "Add"){
        alertMessage.value = i18n.t("err056");
        alertState.value = "error";
        isLoading.value = false;
      }else{
        alertMessage.value = i18n.t("err055");
        alertState.value = "error";
        isLoading.value = false;
      }
    });
};

const validStation_ParentCode = (txtCd) => {
  var re = /^[A-Za-z0-9]+$/;
  return re.test(txtCd);
};

const validCompanyName = (txtCompanyName) => {
  var re = /^[\x20-\x7e]*$/;
  return re.test(txtCompanyName);
};

const validThreeDCode = (threeDCd) => {
  var re = /^[A-Za-z]+$/;
  return re.test(threeDCd);
};

const backProcess = () => {
  store.dispatch("setShowPage", "StationCodeList");
};

const __returned__ = { isLoading, i18n, title1, title2, selectedAreaCode, selectedCountryCode, CompanyName, StationCode, ThreeDigit, ParentCode, titleStatus, areaInfo, oriCountryInfo, countryInfo, alertMessage, alertState, areaError, countryError, companyError, stationError, threeDigitCdError, parentCdError, checkVal, validStCD, validThreeDigit, validParentCD, getAreaAndCountry, getAreaList, getCountryList, setCountryByArea, areaChange, stationAddOrEditProcess, checkCompanyDetailInfo, insertOrUpdateStationInfo, validStation_ParentCode, validCompanyName, validThreeDCode, backProcess, AdminNavigation, Alert }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})